import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CustomerFeConfig } from '../../../../core/interfaces/environment.interface';
import { ConfigService } from '../../../../core/services/config.service';

@Component({
	selector: 'cfe-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
	config: CustomerFeConfig;
	imprintLink: string;
	privacyLink: string;
	termsOfUse: string;
	complianceAndEthics: string;
	dentsplySironaInc: string;
	facebookLink: string;
	twitterLink: string;
	termsAndConditions: string;
	currentLanguage: string;
	onLangChangeSubscription: Subscription;
	year: string;

	constructor(protected translateService: TranslateService, protected configService: ConfigService) {}

	ngOnInit() {
		this.year = (new Date()).getFullYear().toString();
		// Get config
		this.configService.configObservable.subscribe((config) => {
			this.config = config;
		});

		this.onLangChangeSubscription = this.translateService.onLangChange.subscribe((langChangeEvent) => {
			this.currentLanguage = langChangeEvent.lang;
		});
		// Set links for current language
		this.setLinks(this.translateService.currentLang);
		this.translateService.onLangChange.subscribe((language) => {
			this.setLinks(language.lang);
		});
	}

	ngOnDestroy() {
		this.onLangChangeSubscription.unsubscribe();
	}

	/**
	 * Set Cookie links for each language
	 * currently set to german, because only this one is available
	 *
	 * @param language
	 */
	public setLinks(language: string) {
		this.setVanityUrls();
		this.setSocialMediaLinks();

		if (language === 'de-DE') {
			this.imprintLink = this.config.vanityUrls.imprintLink;
		}
	}

	private setVanityUrls() {
		if (this.config && this.config.vanityUrls) {
			this.complianceAndEthics = this.config.vanityUrls.complianceAndEthics;
			this.dentsplySironaInc = this.config.vanityUrls.dentsplySironaInc;
			this.privacyLink = this.config.vanityUrls.privacyLink;
			this.termsOfUse = this.config.vanityUrls.termsOfUse;
			this.termsAndConditions = this.config.vanityUrls.termsAndConditions;
		}
		// imprint only in germany available
		this.imprintLink = null;
	}

	private setSocialMediaLinks() {
		// Social Media Links
		this.facebookLink = 'https://www.facebook.com/dentsplysirona/';
		this.twitterLink = 'https://twitter.com/dentsplysirona';
	}
}
